// Tenant client for /api/user/v1/bug-reports.
import userAxios from "./userAxios";

const bugReports = {
  create: (body) => userAxios.post("/bug-reports", body),
  list: (params) => userAxios.get("/bug-reports", { params }),
  get: (id) => userAxios.get(`/bug-reports/${id}`),
};

export default bugReports;
